export enum ClinicAutoInvoiceSetting {
  ANY = 'any',
  FULL = 'full',
  COPAY = 'copay',
  NONE = 'none',
}
